<ng-content></ng-content>
<div class="image-container">
  <!-- <button class="btn primary fab sm corner-btn">+</button> -->
  <img *ngIf="image?.url1x; else blank" [src]="image?.url1x" alt="Profile image" />
</div>
<ng-template #blank>
  <div class="blank-icon" inlineSVG="/icons/icon-person-v2-current-color.svg"></div>
</ng-template>
